(() => {
  const CART_DRAWER = 'cart-drawer';
  const LIMIT = 3;
  let renderTimer;
  let rendering = false;

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  async function getRecommendations(productId) {
    const url = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=related`;
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) return { products: [] };
    return response.json();
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return `€${(cents / 100).toFixed(2)}`;
    }
  }

  function productCard(product) {
    const variant = (product.variants || []).find(v => v.available) || product.variants?.[0];
    if (!variant || !product.available) return '';

    const image = product.featured_image || product.images?.[0];
    const card = document.createElement('div');
    card.className = 'product-scroll-sell swiper-slide dhc-contextual-upsell';
    card.innerHTML = `
      <div class="product-scroll-image relative">
        ${image ? `<a href="${product.url}" aria-label="${escapeHtml(product.title)}"><img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="250" height="250"></a>` : ''}
        <button type="button" class="addToCart-icon dhc-contextual-upsell-add" data-variant-id="${variant.id}" aria-label="Add ${escapeHtml(product.title)} to cart">
          <span aria-hidden="true">+</span>
        </button>
      </div>
      <div class="product-scroll-text text-sm">
        <a href="${product.url}" class="product-title font-heading">${escapeHtml(product.title)}</a>
        <product-price-list class="product-price-list">
          <product-sale-price class="product-price-actual"><span class="product-actual-price">${formatMoney(variant.price)}</span></product-sale-price>
        </product-price-list>
      </div>
    `;
    return card;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }

  async function addToCart(variantId, button) {
    button.disabled = true;
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Add to cart failed');
      document.dispatchEvent(new CustomEvent('dhc:cart-upsell-added'));
      const drawer = document.querySelector(CART_DRAWER);
      if (drawer?.renderContents) {
        const sectionResponse = await fetch('?section_id=cart-drawer', { credentials: 'same-origin' });
        const html = await sectionResponse.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = parsed.querySelector(CART_DRAWER);
        if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('DHC contextual upsell:', error);
      button.disabled = false;
    }
  }

  async function render() {
    if (rendering) return;
    const root = document.querySelector('product-recommendations');
    if (!root || root.dataset.dhcContextualUpsells === 'done') return;

    rendering = true;
    try {
      const cart = await getCart();
      if (!cart.items?.length) return;

      const inCart = new Set(cart.items.map(item => item.product_id));
      const productIds = [...new Set(cart.items.map(item => item.product_id))].slice(0, 4);
      const pools = await Promise.all(productIds.map(getRecommendations));
      const products = [];
      const seen = new Set();

      for (const pool of pools) {
        for (const product of (pool.products || [])) {
          if (inCart.has(product.id) || seen.has(product.id) || !product.available) continue;
          seen.add(product.id);
          products.push(product);
          if (products.length >= LIMIT) break;
        }
        if (products.length >= LIMIT) break;
      }

      const wrapper = root.querySelector('.swiper-wrapper');
      if (!wrapper || !products.length) return;

      wrapper.innerHTML = '';
      products.forEach(product => {
        const card = productCard(product);
        if (card) wrapper.appendChild(card);
      });

      const heading = root.querySelector('.product-recommendations--title');
      if (heading) heading.textContent = 'COMPLETE YOUR ROUTINE';

      root.dataset.dhcContextualUpsells = 'done';
      root.querySelectorAll('.dhc-contextual-upsell-add').forEach(button => {
        button.addEventListener('click', () => addToCart(button.dataset.variantId, button));
      });

      if (window.Swiper) {
        const slider = root.querySelector('.recommendations-slide');
        if (slider?.swiper) {
          slider.swiper.update();
        }
      }
    } catch (error) {
      console.error('DHC contextual upsell:', error);
    } finally {
      rendering = false;
    }
  }

  function scheduleRender() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(() => {
      const root = document.querySelector('product-recommendations');
      if (root) delete root.dataset.dhcContextualUpsells;
      render();
    }, 250);
  }

  const drawerObserver = new MutationObserver(scheduleRender);
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector(CART_DRAWER);
    if (drawer) drawerObserver.observe(drawer, { childList: true, subtree: true });
    scheduleRender();
  });
  document.addEventListener('dhc:cart-upsell-added', scheduleRender);
})();